export function getCachefilters ({ state, commit }, { search, page }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/cachefilters', { params: { search, page } })
      .then((response) => {
        if (response.data.cachefilters) {
          commit('setCachefilters', response.data.cachefilters)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getCachefilter ({ state, commit }, cachefilterId) {
  return new Promise((resolve, reject) => {
    if (cachefilterId) {
      axiosInstance.get('/v1/cachefilters/' + cachefilterId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No cachefilter id'))
    }
  })
}

export function deleteCachefilter ({ state, commit }, cachefilterId) {
  return new Promise((resolve, reject) => {
    if (cachefilterId) {
      axiosInstance.delete('/v1/cachefilters/' + cachefilterId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No cachefilter id'))
    }
  })
}
